import { h, render } from "preact";
import ProductSwatches from "./product-swatches";

class ProductFormSwatches extends HTMLElement {
  static observedAttributes = ["product-group", "product-id"];

  constructor() {
    super();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;

    render(
      <ProductSwatches
        groupName={this.productGroup}
        productId={this.productId}
        showLabels={this.showLabels}
        onlyActive={this.onlyActive}
      />,
      this
    );
  }

  get productGroup() {
    return this.getAttribute("product-group");
  }

  get productId() {
    return this.getAttribute("product-id");
  }

  get showLabels() {
    return this.hasAttribute("show-labels");
  }

  get onlyActive() {
    return this.hasAttribute("only-active");
  }
}

if (!customElements.get("product-form-swatches")) {
  customElements.define("product-form-swatches", ProductFormSwatches);
}
